import React  from 'react';
import MainCalculatorsList from '../MainCalculators';
import SharedHelmet from '../Helmet';
import RelatedLinks from '../RelatedLinks';
import { CalculatorsType } from '../ConstantsEN';
import { FirstAds, SecondAds , MobileUnderCalAds } from "../../Ads";
import PercentageCalculator from './PercentageCalculator';
const TITLE = 'Calculate 25% Percentage of a Number - 25 Percent Calculator - Discover How Much Is Twenty-Five Percent';
const DESCRIPTION = 'Learn how to accurately calculate 25% of a number using our 25 percent calculator. Find out the value of twenty-five percent easily and efficiently with this online tool.';
const KEYWORDS = 'Calculate 25% Percentage, 25 Percent Calculator, Twenty-Five Percent Value, Percentage Calculator, Calculate Percentage, Percentage Calculation, Online Calculator';
const OG_URL = 'https://do-calculate.com/calculator/en/25percent';
function Calculator() {
    return (
        <div>
            <SharedHelmet TITLE={TITLE} DESCRIPTION={DESCRIPTION} KEYWORDS={KEYWORDS} OG_URL={OG_URL}  />
            <div className="row">
                <div className="col-12 col-md-8">
                    <FirstAds />
                </div>
            </div>
            <div className="row">
                <div className="col-12 col-md-8">
                    <br />
                    <div className="bg-success text-white text-center" style={{ height: '40px' }}>
                        <h1 style={{ fontSize: '17px' }}>{TITLE}</h1>
                    </div>
                            <div className="border border-light">
                                <div className="row">
                                    <div>
                                        <h2 style={{ fontSize: '17px' }}>To calculate 25% of a certain value, you can follow these steps:</h2>
                                        <ul>
                                                <li>Multiply the value by 25% as a fraction. 25% can be represented as a fraction like this: 25/100.</li>
                                                <li>Next, multiply the original value by the fraction formed by the fraction. Let's assume you have a certain value you want to calculate 25% of, let's say this value is 100, you can use the following equation:<br />
                                                    Percentage = (Original Value × Fraction 25/100)
                                                </li>
                                                <li>Alternatively, you can simply perform the calculation by dividing the original value by 4.<br />
                                                    Percentage = Original Value / 4
                                                </li>
                                                <li>You will obtain the desired percentage, which is 25% of the original value.
                                                </li>
                                            </ul>
                                            <b>You can also use the following electronic calculator to calculate 25% of a specific number or amount:</b>
                                        <hr />
                                    </div>
                                </div>
                                 <MobileUnderCalAds/>
                                <div className="row">
                                    <div className="col-sm-12 col-md-7 calculatorStyle">
                                        <div className='p-3 mb-2 bg-success text-white'>
                                            <h2 style={{ fontSize: '16px' }}>{TITLE} </h2>
                                        </div>
                                        <hr />
                                        <PercentageCalculator percentage={25}/>
                                    </div>
                                </div>
                                <hr />
                                <div className="row">
                                    <RelatedLinks />
                                    <hr />
                                </div>
                            </div>
                </div>
                <div className="col" >
                    <SecondAds />
                    <br />
                    <MainCalculatorsList CalculatorsTypeId={CalculatorsType.humanCalculators}></MainCalculatorsList>
                    <br />
                </div>
            </div>
             <br />
        </div>
    );
}
export default Calculator;
